import styled from 'styled-components'
import type { InputStylesProps } from '../Input/Input.styles'
import { getInputStyles } from '../Input/Input.styles'
import { spacing } from '../_styles/spacing'
import type { TextAreaProps } from './TextArea.types'

type StyledTextAreaProps = TextAreaProps &
  InputStylesProps & {
    $resize?: 'both' | 'horizontal' | 'none' | 'vertical'
  }

export const StyledTextArea = styled.textarea<StyledTextAreaProps>`
  ${getInputStyles};

  height: auto; // reset height from getInputStyles to allow 'rows' attribute
  min-height: 64px;
  padding: ${spacing.sm}px ${spacing.md}px;
  resize: ${({ $resize = 'both' }) => $resize};
`
